// extracted by mini-css-extract-plugin
module.exports = {"root":"HomePage_root__1p29e"};